import React from 'react'

export default function About() {
    return (
        <div>
            <div className="container my-6">
            <h1>About Utility Tool</h1>
                <strong><h3>Utility Tool is a project that aims to provide as many online computer utilities (tools) as possible to all users worldwide.
                    Utilities are and will continue to be free of charge.These utilities can be thought of as add-ons to online operating systems (such as Chrome OS).
                    It is a free software and anyone can acess it and do their work.</h3>
                </strong>
                <strong><h3>Utility Tools has following functions:<hr></hr>
                    <ul>
                        <li>It can convert the text into Uppercase.</li>
                        <li>It can convert the text into Lowercase.</li>
                        <li>Remove Extra Spaces frpm the Text.</li>
                        <li>Reverse the text.</li>
                        <li>Copy the text from the textbox.</li>
                        <li>Download the text in the form of txt file.</li>
                    </ul>
                </h3>
                </strong>
                <hr />
                <strong><h3>Other features:
                    <ul>
                        <li>It also counts the number of words as well as characters in the text box.</li>
                        <li>Number of Vowels Present in the text.</li>
                        <li>Number of sentences present in the textbox.</li>
                    </ul>
                </h3>
                </strong>
            </div>
        </div>
    )
}
